module.exports = new __parcel__URL__("generic-background.3268bb58.svg").toString();